import { useTranslation } from 'react-i18next';
import InfoSection from '@/components/Approval/@components/InfoSection';
import { InfluencerMonthlyReportSnapshot } from '@/components/Approval/@components/InfluencerMonthlyReport';
import { parseInfluencerMonthlyContent } from '@/utils/approval/influencerMonthlyReport';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 108 인플루언서 월마감 보고서 — 저장 content 그대로(레거시 문서 포함). 리포트 재조회 안 함 */
const InfluencerMonthlyReportSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const content = parseInfluencerMonthlyContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <InfoSection title={t('인플루언서 월마감 보고서')}>
        <InfluencerMonthlyReportSnapshot content={content} />
      </InfoSection>
    </ContentSlotRoot>
  );
};

export default InfluencerMonthlyReportSlot;
